export const authorizationHeader = 'Authorization';
export const customAuthorizationHeader = 'X-Authorization';
export const contentHeader = 'Content-type';
export const defaultContentType = 'application/json';
